// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__u-GNT","checkmark":"Checkbox_checkmark__grk_N"};